import { HttpService } from '@/infra/http'

export type TValidarSimulacaoParaPropostaResponse =
  | {
      result: true
    }
  | {
      result: false
      errors: Array<{
        code:
          | 'OVERDUE_INSTALLMENT'
          | 'SIMULATION_ALREADY_USED_BY_ANOTHER_PROPOSAL'
          | 'SIMULATION_ACCESSORY_ZEROED'
          | 'PRODUCT_UNAVAILABLE'
          | 'EXPIRED_SIMULATION'
          | 'OPPORTUNITY_CLOSED'
          | 'PLANT_SIMULATION_NOT_ALLOWED_FOR_PROPOSAL'
          | 'OPPORTUNITY_SALESPERSON_IS_TEST_USER'
          | 'OPPORTUNITY_SALESPERSON_MISSING_COMMISSION_PARAMETERS'
        message: string
      }>
    }

export class ValidarSimulacaoParaProposta extends HttpService {
  execute = async (simulacaoId: string) => {
    return this.http.get<TValidarSimulacaoParaPropostaResponse>(
      `/api/v2/Simulacao/${simulacaoId}/disponivelParaProposta`,
    )
  }
}
